<template>
    <v-container
        v-if="getPermission('customers?.read')"
        fluid
        class="b-container"
    >
        <v-sheet class="pa-3">
            <v-row no-gutters align="center" class="pa-5 pt-0">
                <v-col cols="auto">
                    <v-img
                        src="@/assets/customers.png"
                        width="60"
                        height="60"
                    ></v-img>
                </v-col>
                <v-col cols="9" class="pl-5">
                    <h4 v-text="translations.title[lang]"></h4>
                    <div
                        style="font-size: 0.875rem"
                        class="font-weight-medium mt-1"
                        v-text="translations.info[lang]"
                    ></div>
                </v-col>
            </v-row>
            <v-tabs color="secondary" :vertical="$vuetify.breakpoint.mdAndDown">
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.system"
                    v-text="tab.name[lang]"
                    :to="tab.to"
                    @click="resetCurrentTab(tab.system)"
                    class="text-capitalize d-flex justify-lg-center justify-start px-3"
                    :class="{ isCurrentTab: currentTab === tab.system }"
                ></v-tab>
            </v-tabs>
            <v-tabs-items v-model="currentTab">
                <v-tab-item value="customers">
                    <CustomersTab />
                </v-tab-item>
                <v-tab-item value="attributes">
                    <AttributesTab />
                </v-tab-item>
                <v-tab-item value="notifications">
                    <NotificationsTab />
                </v-tab-item>
            </v-tabs-items>
        </v-sheet>
    </v-container>
</template>

<script>
import CustomersTab from "./tabs/CustomersTab.vue";
import AttributesTab from "./tabs/AttributesTab.vue";
import NotificationsTab from "./tabs/NotificationsTab.vue";
import translations from "@/utils/translations/loyaltyPanel/customers";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "Customer",
    components: {
        CustomersTab,
        AttributesTab,
        NotificationsTab,
    },
    mixins: [translations],
    data() {
        return {
            itab: 0,
            // tabs: ["customers", "attributes", "notifications"],
            currentTab: "customers",
        };
    },
    computed: {
        ...mapState(["permissions"]),
        lang() {
            return this.$route.params.lang;
        },
        tabs() {
            let tabs = [
                {
                    name: this.translations.customers,
                    to: `/${this.lang}/loyaltyPanel/customers/customers-tab`,
                    system: "customers",
                },
                {
                    name: this.translations.attributes,
                    to: `/${this.lang}/loyaltyPanel/customers/attributes-tab`,
                    system: "attributes",
                },
                {
                    name: this.translations.notifications,
                    to: `/${this.lang}/loyaltyPanel/customers/notifications-tab`,
                    system: "notifications",
                },
            ];
            return tabs;
        },
    },
    methods: {
        ...mapActions(["getPermission"]),
        resetCurrentTab(name) {
            let i = this.tabs.findIndex((x) => x === name);
            this.itab = i;
            this.currentTab = name;
            this.$nextTick(() => {
                this.currentTab = name;
            });
            this.$nextTick(() => {
                this.itab = i;
            });
        },

        getTabFromRoute() {
            const routeTab = this.$route.name;
            if (routeTab === "CustomersTab") return "customers";
            if (routeTab === "AttributesTab") return "attributes";
            if (routeTab === "NotificationsTab") return "notifications";
            return "customers";
        },
    },
    watch: {
        permissions: {
            handler(val, oldVal) {
                if (val && !this.getPermission("customers?.read")) {
                    this.$router.replace(
                        `/${this.lang}/${this.panelType}/forbidden-gateway`
                    );
                }
            },
            deep: true,
        },
        $route: {
            immediate: true,
            handler(val) {
                this.currentTab = this.getTabFromRoute();
                if (val.path === `/${this.lang}/loyaltyPanel/customers`) {
                    this.$router.push(
                        `/${this.lang}/loyaltyPanel/customers/customers-tab?page=1`
                    );
                }
            },
        },
    },
};
</script>

<style scoped>
.menu-tab {
    margin-top: 0;
    margin-left: 0;
    max-width: 300px;
    position: absolute;
    left: 0;
    background: white;
    width: 100%;
    text-align: left;
    bottom: -22px;
}
.droptab {
    max-width: 300px;
    min-width: 200px;
    margin-left: 10px;
    margin-right: 10px;
    color: white;
}
</style>

<style>
.droptab * {
    text-align: center;
}
.menu-tab .v-input__slot::before {
    border: none !important;
}
.menu-tab .v-input__slot .v-input__append-inner {
    display: none;
}
.menu-tab
    .v-text-field.v-input--is-focused
    > .v-input__control
    > .v-input__slot::after {
    display: none;
}
.menu-tab .v-label {
    text-align: center;
    padding-left: 10px;
    width: 100%;
}
.no-border-field * {
    border: none !important;
}
.input-text-center input {
    text-align: center;
}
.table-chips {
    max-height: 200px;
    overflow: auto;
}
.table-chips .v-slide-group__wrapper {
    overflow: auto;
}
</style>
